import * as React from "react";

import { Kit, KitOverview } from "./components";


export default  class Promo extends React.Component<{}> {
    public render() {
        const kit: Kit = {
            id: "fiber",
            name: "Fiber with Firebase",
            overview: "A UI Kit focused on animations inspired by Framer.",
            price: {
                value: 10000,
                currency: "USD"
            },
            // tslint:disable-next-line:max-line-length
            description: "Fiber is an iOS and Android React Native theme heavily focused on animations. Support Firebase Authentication and Cloud Firestore.",
            documentation: "https://wcandillon.github.io/react-native-fiber/",
            color: "#58b1f1",
            expo: "exp://exp.host/@wcandillon/react-native-fiber-firebase",
            thumbnail: require("./components/kits/fiber.jpg"),
            thumbnailPreview: require("./components/kits/fiber-preview.jpg"),
            testFlight: "https://testflight.apple.com/join/TUuAnOpj",
            apk: null
        };
        return (
            <KitOverview reverse={false} specialPromo={true} {...{kit}} />
        );
    }
}



// WEBPACK FOOTER //
// ./src/Promo.tsx